import styled from 'styled-components';

import { colors, fontSizes } from 'ui/theme';

import { RECENT_EVENTS_ROW_COUNT } from '../constants';

export const PlaceholderListItem = styled.li<{ $rowSpan: number }>`
  grid-row: ${({ $rowSpan }) => RECENT_EVENTS_ROW_COUNT - $rowSpan + 1} / span
    ${({ $rowSpan }) => $rowSpan};
  color: ${colors.textDisabled};
  font-size: ${fontSizes.s14};
  text-align: center;
  align-self: center;
`;
